import styled from '@emotion/styled/macro'
import mediaQuery from 'share/utils/mediaQuery'

import { flexCenter } from 'style/emotion'

const ContentNotAvailableContainer = styled('section')`
  ${flexCenter}

  flex-direction: column;
  height: auto;
`

const ContentNotAvailableIconContainer = styled('div')`
  ${flexCenter}

  background-color: var(--london-fog);
  border-radius: 80px;
  height: 80px;
  margin-bottom: 16px;
  width: 80px;
`

const ContentNotAvailableIcon = styled('span')`
  color: var(--slate-60);
  font-size: 3rem;
  &.light-icon {
    color: var(--gray-1);
  }
`

const ContentNotAvailableText = styled('p')`
  color: var(--CINight);
  margin: 0;
  .cases-no-active-cases-message-wrapper {
    .cases-no-active-cases-message {
      ${mediaQuery('tablet')} {
        width: 100%;
      }
    }
    .btn.retry-btn {
      width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
`

export {
  ContentNotAvailableContainer,
  ContentNotAvailableIcon,
  ContentNotAvailableIconContainer,
  ContentNotAvailableText
}
